import React from 'react'
import { array, string } from 'prop-types'
import SubTypeItem from './SubTypeItem'

const ListItemMap = ({ subtypes, theme }) =>
  subtypes.map(subtype => (
    <SubTypeItem
      key={subtype[0]}
      subtype={subtype[0]}
      color={subtype[1]}
      theme={theme}
    />
  ))

ListItemMap.propTypes = {
  subtypes: array.isRequired,
  theme: string.isRequired,
}

export default ListItemMap



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeMenu/ListItemMap.jsx